export default "__VITE_ASSET__nq$n63z8__"